<template>
  <div class="root">
    <p class="mode">
      <span>资料下载</span>
      <router-link to="/dataDownload">更多></router-link>
    </p>
    <ul class="xianwenList">
      <li v-for="(item, index) in list0" :key="index">
        <router-link :to="{ name: '资料下载详情', query: { id: item.id } }">
          <span :title="item.title">{{ item.title }}</span>
          <span>[{{ sub(item.logintime) }}]</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list0: [],
    }
  },
  created() {
    // 资料下载数据
    let url = 'ziliaoxiazai'
    // console.log("资料下载");
    // console.log(this.ajax_url(url).data);
    this.list0 = this.ajax_data(url, { number: '007' }).data
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    sub(str) {
      return str.substr(0, 10)
    },
  },
}
</script>

<style scoped>
.root {
  min-height: 1180px;
  width: 100%;
  height: 380px;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
  overflow: hidden;
}

.mode {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 26px 0 37px;
  width: 495px;
  height: 80px;
  border-bottom: 1px solid #dbdbdb;
}

.mode > span {
  display: block;
  width: auto;
  height: 80px;
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2187ff;
  line-height: 80px;
}

.mode > a {
  display: block;
  width: auto;
  height: 80px;
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 80px;
}

.xianwenList {
  padding: 16px 32px 0 34px;
  width: 492px;
  height: 282px;
  overflow: hidden;
  /* background-color: chocolate; */
}

.xianwenList > li {
  width: 492px;
  height: 54px;
  line-height: 27px;
  overflow: hidden;
}

.xianwenList > li > a {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  height: 23px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 23px;
  overflow: hidden;
}

.xianwenList > li > a > span:first-child {
  padding-left: 22px;
  width: 270px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background: url('../../../assets/img/i1.png') no-repeat left center;
}
</style>
